import { useEffect, useRef, useState } from 'react';

import { getEventReportRange, toEventPickerDate } from './eventTime';

export default function useEventReport(getReport, onError) {
  const [event, setEvent] = useState(null);
  const [range, setRange] = useState(null);
  const [report, setReport] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const requestVersion = useRef(0);
  const request = useRef(null);

  const invalidate = () => {
    requestVersion.current += 1;
    request.current?.abort?.();
    request.current = null;
    setIsLoading(false);
    setReport(null);
  };

  useEffect(
    () => () => {
      requestVersion.current += 1;
      request.current?.abort?.();
    },
    [],
  );

  const open = nextEvent => {
    invalidate();
    setEvent(nextEvent);
    setRange([toEventPickerDate(nextEvent.startAt), toEventPickerDate(nextEvent.endAt)]);
  };

  const close = () => {
    invalidate();
    setEvent(null);
  };

  const changeRange = nextRange => {
    invalidate();
    setRange(nextRange);
  };

  const load = async () => {
    if (!event || !range?.[0] || !range?.[1]) return;
    invalidate();
    const version = requestVersion.current;
    setIsLoading(true);
    try {
      request.current = getReport({ id: event.id, ...getEventReportRange(range) });
      const response = await request.current.unwrap();
      if (version === requestVersion.current) setReport(response);
    } catch (error) {
      if (version === requestVersion.current) onError(error);
    } finally {
      if (version === requestVersion.current) {
        request.current = null;
        setIsLoading(false);
      }
    }
  };

  return { event, range, report, isLoading, open, close, changeRange, load };
}
